import script from "./languageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./languageView.vue?vue&type=script&lang=ts&setup=true"

import "./languageView.vue?vue&type=style&index=0&id=86f0e014&lang=css"

const __exports__ = script;

export default __exports__